enum TaxRoundingMode {
  Round = 'round',
  Ceil = 'ceil',
  Floor = 'floor',
}

export { TaxRoundingMode };
